// // import { useState } from 'react';
// // import { useContext, useRef } from 'react';
// // import ModalSvcContext from 'src/shared/services/modal/modal.context';
// // import ModalService from 'src/shared/services/modal/modal.service';
// // import APP_MODALS from 'src/static/enums/app.modals';
// // import Button from 'src/components/internal/button/button.component';

// // export default function ContentAcceptanceModal() {
// // 	const modalRef = useRef<HTMLDivElement>(null);
// // 	const modalContentRef = useRef<HTMLDivElement>(null); // Ref for modal content
// // 	const modalSvc = useContext<ModalService>(ModalSvcContext);

// // 	// Function to close the modal
// // 	const closeModal = () => {
// // 		modalSvc.closeModal(APP_MODALS.CONTENT_ACCEPTANCE_MODAL);
// // 	};
// // 	const [points, setPoints] = useState(0); // Initial points value
// // 	const [focused, setFocused] = useState(false); // Track input focus state

// // 	// Function to update points on the server (implement your API call here)
// // 	const updatePoints = async (newPoints: any) => {
// // 		try {
// // 			// Example API call - replace with your actual implementation
// // 			// await fetch('/api/update-points', {
// // 			//     method: 'POST',
// // 			//     body: JSON.stringify({ points: newPoints })
// // 			// });
// // 			console.log('Points updated:', newPoints);
// // 		} catch (error) {
// // 			console.error('Error updating points:', error);
// // 		}
// // 	};

// // 	const verified = true;

// // 	return (
// // 		<main
// // 			className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10]"
// // 			tabIndex={-1}
// // 			ref={modalRef}
// // 		>
// // 			<div
// // 				ref={modalContentRef}
// // 				className=" w-[343px] p-6 rounded-lg bg-white dark:bg-dark-50 min-h-[200px] md:w-[512px]"
// // 			>
// // 				{/* the modal gen con */}
// // 				<div className="flex items-center w-full">
// // 					{/* the title and the close icon */}
// // 					<div className="flex items-center justify-between w-full">
// // 						<h3 className="text-2xl font-bold leading-9">Accept Submission</h3>
// // 						{/* icon */}
// // 						<div onClick={closeModal} className="cursor-pointer">
// // 							<i className="fa-solid fa-xmark "></i>
// // 						</div>
// // 					</div>
// // 				</div>
// // 				<h6 className="text-base font-normal leading-[26px] mt-6">
// // 					Please assign quest points to reward the user for their contribution.
// // 				</h6>
// // 				<div className="flex items-center h-fit justify-between bg-gray-50 my-6 dark:bg-dark-700 dark:text-white py-[8px] px-[10px] rounded-lg w-full mt-5">
// // 					{/* <span className="font-semibold text-black text-2xl dark:text-white">
// // 						Total Points
// // 					</span> */}
// // 					<div
// // 						// className={`flex h-[65px] transition duration-100 ease-in items-center space-x-6 bg-gray-100 dark:bg-dark-800 p-2 rounded-lg ${
// // 						// 	focused ? 'border border-ablue-200' : ''
// // 						// }`}
// // 						className="flex items-center justify-between w-full"
// // 					>
// // 						{/* Minus Button */}
// // 						<div className="relative group">
// // 							<button
// // 								onClick={() => {
// // 									const updatedPoints = points - 50;
// // 									setPoints(updatedPoints);
// // 									updatePoints(updatedPoints);
// // 								}}
// // 								className="hover:bg-ablue-100 hover:text-white transition duration-100 ease-in-out bg-white text-black border rounded w-10 h-10 flex items-center justify-center"
// // 							>
// // 								–
// // 							</button>
// // 						</div>

// // 						{/* Points Display */}
// // 						<span className="font-bold text-3xl text-black flex items-center">
// // 							<input
// // 								type="number"
// // 								value={points}
// // 								onChange={(e) => setPoints(Number(e.target.value))}
// // 								onFocus={() => setFocused(true)}
// // 								onBlur={() => setFocused(false)}
// // 								className="text-3xl bg-transparent dark:text-white text-center focus:outline-none"
// // 								style={{ width: `${String(points).length + 2}ch` }}
// // 								onKeyDown={(e) => {
// // 									if (e.key === 'Enter') {
// // 										updatePoints(points);
// // 										setFocused(false);
// // 									}
// // 								}}
// // 							/>
// // 							<img
// // 								src="/Points logo/points.svg"
// // 								alt="Points"
// // 								className="ml-1 h-7 w-7 text-blue-500"
// // 							/>
// // 						</span>

// // 						{/* Plus Button */}
// // 						<div className="relative group">
// // 							<button
// // 								onClick={() => {
// // 									const updatedPoints = points + 50;
// // 									setPoints(updatedPoints);
// // 									updatePoints(updatedPoints);
// // 								}}
// // 								className="hover:bg-ablue-100 hover:text-white transition duration-100 ease-in-out bg-white text-black border rounded w-10 h-10 flex items-center justify-center"
// // 							>
// // 								+
// // 							</button>
// // 						</div>
// // 					</div>
// // 				</div>

// // 				{/* the buttons */}
// // 				<div className="flex items-center gap-x-3 mt-4">
// // 					<Button className="secondary w-full">Reject</Button>
// // 					<Button
// // 						className={`w-full ${
// // 							verified
// // 								? 'ghostgray !text-ghostly_grey-300 dark:!bg-agrey-800 dark:border-none'
// // 								: 'blue'
// // 						}`}
// // 						// onClick={() => open}
// // 					>
// // 						Accept
// // 					</Button>
// // 				</div>
// // 			</div>
// // 		</main>
// // 	);
// // }

// import ModalSvcContext from 'src/shared/services/modal/modal.context';
// import ModalService from 'src/shared/services/modal/modal.service';
// import APP_MODALS from 'src/static/enums/app.modals';
// import { useContext, useRef, useState } from 'react';
// import Button from 'src/components/internal/button/button.component';

// export default function CreateProgramModal() {
// 	const modalRef = useRef<HTMLDivElement>(null);
// 	const modalContentRef = useRef<HTMLDivElement>(null); // Ref for modal content
// 	const modalSvc = useContext<ModalService>(ModalSvcContext);

// 	const [points, setPoints] = useState(0); // Initial points value
// 	const [focused, setFocused] = useState(false); // Track input focus state

// 	const closeModal = () => {
// 		modalSvc.closeModal(APP_MODALS.CONTENT_ACCEPTANCE_MODAL);
// 	};

// 	function updatePoints(points: number) {
// 		throw new Error('Function not implemented.');
// 	}
// 	const verified = false;

// 	// State to manage the selected rejection reason
// 	const [selectedReason, setSelectedReason] = useState('');

// 	// Handle checkbox change
// 	const handleReasonChange = (reason: string) => {
// 		setSelectedReason(reason);
// 	};

// 	// Handle reject button click
// 	const handleReject = () => {
// 		if (selectedReason) {
// 			onReject(selectedReason); // Pass the selected reason to the parent component
// 			onClose(); // Close the modal
// 		} else {
// 			alert('Please select a reason for rejection.');
// 		}
// 	};

// 	// Handle cancel button click
// 	const handleCancel = () => {
// 		setSelectedReason(''); // Reset the selection
// 		onClose(); // Close the modal
// 	};

// 	// List of rejection reasons
// 	const reasons = [
// 		'Copyright or Plagiarism',
// 		'Low Quality or Lacks Detail',
// 		'Spam or Promotional Content',
// 		'Duplicate or Already Covered',
// 		'Off-Topic or Misleading',
// 	];

// 	return (
// 		<main
// 			className="fixed inset-0 bg-black bg-opacity-50 pointer-events-auto flex items-center justify-center z-[10]"
// 			tabIndex={-1}
// 			ref={modalRef}
// 		>
// 			<div
// 				ref={modalContentRef}
// 				className="w-[343px] p-6 rounded-lg bg-white dark:bg-dark-50 min-h-[200px] max-h-fit md:w-[512px]"
// 			>
// 				<div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
// 					{/* Header */}
// 					<div className="flex justify-between items-center mb-4">
// 						<h2 className="text-xl font-semibold text-gray-800">Reject Submission</h2>
// 						<button
// 							onClick={handleCancel}
// 							className="text-gray-500 hover:text-gray-700 text-2xl"
// 						>
// 							&times;
// 						</button>
// 					</div>

// 					{/* Description */}
// 					<p className="text-gray-600 mb-4">
// 						Please select a reason for rejection so the user understands how they can
// 						improve.
// 					</p>

// 					{/* Rejection Reasons */}
// 					<div className="space-y-3">
// 						{reasons.map((reason) => (
// 							<label key={reason} className="flex items-center space-x-2">
// 								<input
// 									type="checkbox"
// 									checked={selectedReason === reason}
// 									onChange={() => handleReasonChange(reason)}
// 									className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
// 								/>
// 								<span className="text-gray-700">{reason}</span>
// 							</label>
// 						))}
// 					</div>

// 					{/* Buttons */}
// 					<div className="flex justify-end space-x-3 mt-6">
// 						<button
// 							onClick={handleCancel}
// 							className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
// 						>
// 							Cancel
// 						</button>
// 						<button
// 							onClick={handleReject}
// 							className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
// 						>
// 							Reject
// 						</button>
// 					</div>
// 				</div>
// 			</div>
// 		</main>
// 	);
// }

import ModalSvcContext from 'src/shared/services/modal/modal.context';
import ModalService from 'src/shared/services/modal/modal.service';
import APP_MODALS from 'src/static/enums/app.modals';
import { useContext, useRef, useState } from 'react';
import Button from 'src/components/internal/button/button.component';
import { toast } from 'react-toastify';
import QueryApi from 'src/shared/api/query-api';
import { useMutation } from 'react-query';

export default function CreateProgramModal() {
	const modalRef = useRef<HTMLDivElement>(null);
	const modalContentRef = useRef<HTMLDivElement>(null);
	const modalSvc = useContext<ModalService>(ModalSvcContext);

	const modalSvcData = modalSvc.getModals().value[0].data || {};

	const { submissionId } = modalSvcData || {};

	// State to manage the selected rejection reason
	const [selectedReason, setSelectedReason] = useState('');

	// Handle checkbox change
	const handleReasonChange = (reason: string) => {
		setSelectedReason(reason);
	};

	const closeRejectionModal = () => {
		modalSvc.closeModal(APP_MODALS.REJECTION_REASON_MODAL);
	};

	// Here I am letting the local storage to know that we have clicked  the reject button so that we can refetch the data on the submit content page

	const handleClick = () => {
		localStorage.setItem('modalConfirmed', 'true');
		// Manually dispatch a storage event for same-tab communication
		window.dispatchEvent(
			new StorageEvent('storage', {
				key: 'modalConfirmed',
				newValue: 'true',
			})
		);
	};

	// List of rejection reasons
	const reasonsData = [
		{ title: 'Copyright or Plagiarism', value: 'copyright-plagiarism' },
		{ title: 'Low Quality or Lacks Detail', value: 'low-quality' },
		{ title: 'Spam or Promotional Content', value: 'spam-content' },
		{ title: 'Duplicate or Already Covered', value: 'duplicate' },
		{ title: 'Off-Topic or Misleading', value: 'off-topic' },
	];
	const rejectMutation = useMutation({
		mutationFn: ({ submissionId, reason }: { submissionId: string; reason: string }) =>
			QueryApi.admin.rejectSubmission(submissionId, reason),

		onSuccess: async () => {
			toast.success('Decision made successfully');
			handleClick();
			closeRejectionModal();
		},

		onError: () => {
			toast.error('Something happened');
		},
	});

	const rejectSubmission = (submissionId: string, reason: string) => {
		rejectMutation.mutate({ submissionId, reason });
	};

	return (
		<main
			className="fixed inset-0 bg-black bg-opacity-50 pointer-events-auto flex items-center justify-center z-[200]"
			tabIndex={-1}
			ref={modalRef}
		>
			<div
				ref={modalContentRef}
				className="w-[343px]  rounded-lg bg-white dark:bg-dark-800 min-h-[200px] max-h-fit md:w-[470px]"
			>
				<div className=" px-[32px] rounded-lg w-full">
					{/* Header */}
					<div className="flex justify-between items-center my-[24px]">
						<h2 className="text-[24px] font-bold leading-[36px] dark:text-white">
							Reject Submission
						</h2>
						<button
							onClick={closeRejectionModal}
							className="text-gray-500 hover:text-gray-700 dark:text-white text-2xl flex items-center justify-center rounded-[4px] size-5 hover:bg-light-700 hover:p-2 dark:hover:bg-dark-700"
						>
							<i className="fa-solid fa-xmark text-sm"></i>
						</button>
					</div>

					{/* Description */}
					<p className="text-[16px] font-normal leading-[26px] mb-[16px] dark:text-white">
						Please select a reason for rejection so the user understands how they can
						improve.
					</p>

					{/* Rejection Reasons */}
					<div className="space-y-3">
						{reasonsData.map((reason, index) => (
							<label
								key={index}
								className="flex items-center justify-between space-x-2 h-[40px] py-[4px] px-[16px] cursor-pointer bg-light-700 dark:bg-dark-700 rounded-[8px]"
							>
								<span className=" text-[12px] font-normal leading-[18px] dark:text-white ">
									{reason.title}
								</span>
								<input
									type="checkbox"
									checked={selectedReason === reason.value}
									onChange={() => handleReasonChange(reason.value)}
									className="checkbox"
								/>
							</label>
						))}
					</div>

					{/* Buttons */}
					<div className="flex justify-end space-x-3 mt-6 mb-8">
						<Button className="secondary w-full" onClick={closeRejectionModal}>
							Cancel
						</Button>
						<Button
							className="w-full red"
							onClick={() => rejectSubmission(submissionId, selectedReason)}
						>
							Reject
						</Button>
					</div>
				</div>
			</div>
		</main>
	);
}
